import { HmClient } from '../HmContext';
import { useClientContext } from './useClientContext';

export function useClientState(): HmClient {
  const {client} = useClientContext();
  return client;
}
